import { createStyles, Grid, Title, Text, Button, Image, rem } from "@mantine/core";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer";
import Reveal from "./Reveal";
import { homePrimaryButton } from "./homeButtonStyles";
import { homeSectionPy } from "../constant/Responsive";

const useStyles = createStyles((theme, { altBackground }) => ({
  section: {
    paddingTop: altBackground ? rem(28) : rem(homeSectionPy.md),
    paddingBottom: rem(homeSectionPy.md),
    backgroundColor: altBackground ? theme.colors.gray[0] : theme.white,
    [theme.fn.smallerThan("sm")]: {
      paddingTop: rem(homeSectionPy.base),
      paddingBottom: rem(homeSectionPy.base),
    },
  },
  imageWrap: {
    position: "relative",
    aspectRatio: "5 / 4",
    overflow: "hidden",
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[2]}`,
    lineHeight: 0,
    backgroundColor: theme.colors.gray[0],
    "& .mantine-Image-root": {
      display: "block",
      width: "100%",
      height: "100%",
      position: "absolute",
      inset: 0,
    },
    "& .mantine-Image-image": {
      objectFit: "cover",
      objectPosition: "center center",
      width: "100%",
      height: "100%",
      display: "block",
    },
  },
  headingRow: {
    display: "flex",
    alignItems: "center",
    gap: rem(8),
    marginBottom: theme.spacing.sm,
  },
  titleFlag: {
    width: rem(72),
    height: rem(50),
    objectFit: "contain",
    flexShrink: 0,
    display: "block",
    border: "none",
    boxShadow: "none",
    background: "transparent",
  },
  heading: {
    fontFamily: theme.headings?.fontFamily || '"Noto Serif TC", serif',
    fontSize: "clamp(1.35rem, 2.2vw, 1.65rem)",
    fontWeight: 600,
    color: theme.colors.gray[8],
    letterSpacing: "0.03em",
    marginBottom: 0,
  },
  body: {
    color: theme.colors.gray[6],
    fontSize: theme.fontSizes.md,
    lineHeight: 1.75,
    marginBottom: theme.spacing.lg,
    maxWidth: 480,
  },
  cta: homePrimaryButton(theme),
}));

export default function ImageWithText({
  image,
  imageAlt,
  title,
  titleFlag,
  body,
  ctaLabel,
  ctaTo,
  imagePosition = "left",
  altBackground = false,
}) {
  const { classes } = useStyles({ altBackground });

  const imageCol = (
    <Grid.Col span={12} md={6}>
      <div className={classes.imageWrap}>
        <Image src={image} alt={imageAlt || title} fit="cover" height="100%" width="100%" loading="lazy" />
      </div>
    </Grid.Col>
  );

  const textCol = (
    <Grid.Col span={12} md={6}>
      <Reveal>
        <div className={classes.headingRow}>
          {titleFlag && (
            <img src={titleFlag} alt="" className={classes.titleFlag} aria-hidden />
          )}
          <Title order={2} className={classes.heading}>
            {title}
          </Title>
        </div>
      </Reveal>
      <Reveal delay={100}>
        <Text className={classes.body}>{body}</Text>
      </Reveal>
      {ctaLabel && ctaTo && (
        <Reveal delay={200}>
          <Link to={ctaTo} style={{ textDecoration: "none" }}>
            <Button className={classes.cta} radius="md" size="md">
              {ctaLabel}
            </Button>
          </Link>
        </Reveal>
      )}
    </Grid.Col>
  );

  return (
    <section className={classes.section}>
      <PageContainer>
        <Grid align="center" gutter={40}>
          {imagePosition === "right" ? (
            <>
              {textCol}
              {imageCol}
            </>
          ) : (
            <>
              {imageCol}
              {textCol}
            </>
          )}
        </Grid>
      </PageContainer>
    </section>
  );
}
